function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.32502 2.175L7.93002 3.57C7.77002 3.73 7.88001 4 8.10501 4H9.00002C9.00002 5.655 7.65501 7 6.00002 7C5.60502 7 5.22002 6.925 4.87502 6.78C4.69502 6.705 4.49002 6.76 4.35502 6.895C4.10002 7.15 4.19002 7.58 4.52502 7.715C4.98002 7.9 5.48002 8 6.00002 8C8.21002 8 10 6.21 10 4H10.895C11.12 4 11.23 3.73 11.07 3.575L9.67502 2.18C9.58002 2.08 9.42002 2.08 9.32502 2.175ZM3.00002 4C3.00002 2.345 4.34502 1 6.00002 1C6.39502 1 6.78002 1.075 7.12502 1.22C7.30502 1.295 7.51002 1.24 7.64502 1.105C7.90002 0.85 7.81002 0.42 7.47502 0.285C7.02002 0.1 6.52002 0 6.00002 0C3.79002 0 2.00002 1.79 2.00002 4H1.10502C0.880015 4 0.770015 4.27 0.930015 4.425L2.32502 5.82C2.42502 5.92 2.58002 5.92 2.68002 5.82L4.07502 4.425C4.23002 4.27 4.12002 4 3.89502 4H3.00002Z",
  fill: "#547EBD"
});
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.584aa25bb1a3d074d5c8d1618a84f653.svg";
export { ForwardRef as ReactComponent };